exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-buttons .btn {\n  margin-right: 20px; }\n\n.modal-content {\n  color: #7d7d7d; }\n\n.form-group label {\n  color: #000; }\n\n.form-control {\n  color: #464a4c;\n  border: 1px solid rgba(0, 0, 0, 0.15); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/shared/components/commentModal/commentModal.component.scss
// module id = 1459
// module chunks = 18